import { RestDictionaryService } from '@sitecore-jss/sitecore-jss-vue';
import config from '../temp/config';
import { canUseDOM } from '@/utils/dom-utils';

export class DictionaryServiceFactory {
  create() {
    // 在客户端运行时，使用当前域名作为API主机，这样请求会通过代理
    // 在服务端渲染时，使用配置的API主机
    const apiHost = canUseDOM() ? window.location.origin : config.sitecoreApiHost;

    return new RestDictionaryService({
      apiHost: apiHost,
      apiKey: config.sitecoreApiKey,
      siteName: config.sitecoreSiteName || 'probio-portal',
    });
  }
}

export const dictionaryServiceFactory = new DictionaryServiceFactory();
